export const loadEmojiShortList = () => import('./emojiShortList');
